import { render, staticRenderFns } from "./ImportLaborWorkerDetail.vue?vue&type=template&id=f9f0ff94&"
import script from "./ImportLaborWorkerDetail.vue?vue&type=script&lang=ts&"
export * from "./ImportLaborWorkerDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports